export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11304.b4ed27db.jpg";